import moment from 'moment'
import React from 'react'

export default function UpcomingTrainings(props) {

    const { graph } = props

    return (
        <div className="widget widget-table-one">
            <div className="widget-header dash_head">
                <h5>Upcoming Trainings</h5>
            </div>

            {graph && graph.length ?
                <div className="widget-content mt-3">
                    {graph && graph.map((value, index) =>
                        <div className="weekly-bestsellers" key={index}>
                            <div className="t-company-name d-flex justify-content-between">
                                <div className="t-name">
                                    <h6>{value && value.lms_training && value.lms_training.training_title}</h6>
                                    <p className="meta-date">{value && value.lms_training && value.lms_training.training_mode}</p>
                                </div>
                                <div className="t-icon">
                                    <span className="badge bg-success">
                                        {value?.lms_training?.start_date && moment(value?.lms_training?.start_date).format('DD/MM/YYYY') + ' at ' + value.lms_training.start_time}

                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                :
                <h6>Training's not found!</h6>
            }
        </div>
    )
}
